// Moyens de paiement locaux IMMO BF — source de vérité unique.
//
// Le système de paiement des abonnements est limité à TROIS moyens :
//   1. Orange Money — 64 59 17 18 (preuve obligatoire)
//   2. Moov Money   — 72 62 19 01 (preuve obligatoire)
//   3. Espèces      — aucune preuve requise
//
// Aucun autre moyen (ni virement, ni carte bancaire, ni Stripe / PayPal).
// Paiement manuel local vérifié par preuve, validé par le Super Admin.

export type PaiementMethode = "orange_money" | "moov_money" | "especes";

export interface MethodePaiement {
  value: PaiementMethode;
  label: string;
  /** Numéro marchand à créditer (null pour les espèces). */
  numero: string | null;
  /** La preuve de paiement est-elle obligatoire ? */
  preuveObligatoire: boolean;
  icon: string;
  /** Instruction courte affichée au client. */
  instruction: string;
}

export const METHODES_PAIEMENT: MethodePaiement[] = [
  {
    value: "orange_money",
    label: "Orange Money",
    numero: "64 59 17 18",
    preuveObligatoire: true,
    icon: "ri-smartphone-line",
    instruction:
      "Effectuez le transfert vers le numéro Orange Money ci-dessus, puis joignez la capture du reçu.",
  },
  {
    value: "moov_money",
    label: "Moov Money",
    numero: "72 62 19 01",
    preuveObligatoire: true,
    icon: "ri-smartphone-line",
    instruction:
      "Effectuez le transfert vers le numéro Moov Money ci-dessus, puis joignez la capture du reçu.",
  },
  {
    value: "especes",
    label: "Espèces",
    numero: null,
    preuveObligatoire: false,
    icon: "ri-money-cny-circle-line",
    instruction:
      "Réglez en espèces auprès de l'équipe IMMO BF. Aucune preuve n'est requise : un agent validera votre paiement.",
  },
];

export const PAIEMENT_METHODE_CODES: PaiementMethode[] = METHODES_PAIEMENT.map((methode) => methode.value);

/** Retourne les informations d'un moyen de paiement (repli sûr sur Espèces). */
export function getMethodePaiement(value: PaiementMethode): MethodePaiement {
  return (
    METHODES_PAIEMENT.find((methode) => methode.value === value) ??
    (METHODES_PAIEMENT[2] as MethodePaiement)
  );
}

/* ------------------------------------------------------------------ */
/* Preuves de paiement (Supabase Storage, bucket privé)                */
/* ------------------------------------------------------------------ */

/** Bucket Supabase PRIVÉ des preuves de paiement (jamais public). */
export const PREUVES_BUCKET = "preuves-abonnements";
export const PREUVE_MAX_SIZE = 5 * 1024 * 1024; // 5 Mo
export const PREUVE_ACCEPT = "image/png,image/jpeg,image/webp,application/pdf";
export const PREUVE_MIME_TYPES = ["image/png", "image/jpeg", "image/webp", "application/pdf"];
export const PREUVE_EXTENSIONS = ".png, .jpg, .jpeg, .webp, .pdf";